import React from 'react';
import DocsPage from './components/DocsPage';

function App() {
  return (
    <DocsPage />
  );
}

export default App;
